import {Icon} from 'antd'
import {filterIconByPre} from '@/utils/tool'

const IconFont = Icon.createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_1500715_owbq035716.js',
});
IconFont.pre = 'xqd'

export default IconFont